/**
 * 在 Vue Router 读取首屏地址前规范化多余的前导斜杠。
 *
 * 浏览器允许 `//aianalyse` 作为 pathname，但 Vue Router 会将它判为
 * 非法的多斜杠路由并命中兜底页。这里只修正 pathname，查询参数和 hash
 * 必须原样保留，避免直达演示场景时丢失开关参数。
 */
export function normalizeInitialBrowserLocation(browserWindow = globalThis.window) {
  const location = browserWindow?.location
  const history = browserWindow?.history
  if (!location || typeof history?.replaceState !== 'function') return null

  const pathname = String(location.pathname || '/')
  const normalizedPathname = pathname.replace(/^\/{2,}/, '/')
  if (normalizedPathname === pathname) return null

  const normalizedLocation = `${normalizedPathname}${location.search || ''}${location.hash || ''}`
  history.replaceState(history.state, '', normalizedLocation)
  return normalizedLocation
}
